import Dialog from '@123/druid/dist/Components/Window/Dialog/Dialog';
import ButtonFactory from '@Component/Button/ButtonFactory';

export default class DialogFactory {
    /**
     * @param {string} title - A confirm dialog does not necessarily need a title, but you could add one nonetheless
     * @param {string} content - the text display on the dialog
     */
    public static confirmDialog(content: string, title?: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const dialog = new Dialog({
                icon: 'dr-icon-question-mark',
                title: title,
                content: content,
                dialogClass: 'dr-dialog-frame--confirm',
                minHeight: 0,
                maxWidth: 360,
                edgeMargin: 32,
                closeOnClickOverlay: false,
                draggable: false,
            });

            const confirmButton = ButtonFactory.createYesButton();
            confirmButton.addEventListener('click', () => {
                dialog.hide();
                resolve();
            });

            dialog.setDefaultButton(confirmButton).addCloseButton(ButtonFactory.createNoButton()).onClose(reject).show();

            // focus default button
            confirmButton.focus();
        });
    }

    public static async contentDialog(content: string, title?: string, width: number = 800, height: number = 640): Promise<void> {
        return new Promise(() => {
            new Dialog({
                icon: 'dr-icon-question-mark',
                title: title,
                content: content,
                dialogClass: 'dr-dialog-frame--content',
                minHeight: 0,
                maxHeight: height,
                maxWidth: width,
                edgeMargin: 32,
                closeOnClickOverlay: true,
                closeButtonText: '%%LANG_POPUP_BTN_CLOSE%%',
                draggable: false,
            }).show();
        });
    }
}
